import axios from 'axios';

export default async (params) => {
  const fullParams = {
    ajax_basket: 'Y',
    'prop[0]': 0,
    ...params,
  };
  const formData = new FormData();
  const paramsKeys = Object.keys(fullParams);

  paramsKeys.forEach((key) => {
    formData.append(key, fullParams[key]);
  });
  const data = new URLSearchParams(formData);

  try {
    const response = await axios.post(
      '/local/ajax/basket/sendToBasket.php',
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );

    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};
